import {
  TrendingUp, Brain, Bot, Crown, Zap, Activity, Shield, Building2,
  Store, Headphones, Workflow, ShieldCheck, UserCheck, Users, Settings, AlertTriangle,
} from "lucide-react";

const TABS = [
  { id: "overview", label: "Visao Geral", icon: TrendingUp },
  { id: "command_center", label: "AI Command", icon: Brain },
  { id: "simone", label: "IA Simone", icon: Bot },
  { id: "investors", label: "Investidores", icon: Crown },
  { id: "jarvis", label: "Jarvis", icon: Brain },
  { id: "ai_usage", label: "Consumo IA", icon: Zap },
  { id: "events", label: "Eventos", icon: Activity },
  { id: "dr", label: "DR", icon: Shield },
  { id: "metrics", label: "Metricas", icon: Activity },
  { id: "restaurants", label: "Restaurantes", icon: Building2 },
  { id: "restaurant_mgmt", label: "Criar/Monitor", icon: Store },
  { id: "suporte", label: "Suporte", icon: Headphones },
  { id: "tasks", label: "Tarefas", icon: Workflow },
  { id: "observability", label: "Observabilidade", icon: Activity },
  { id: "health", label: "Saude", icon: ShieldCheck },
  { id: "affiliates", label: "Afiliados", icon: UserCheck },
  { id: "partner_apps", label: "Candidaturas", icon: Users },
  { id: "leads", label: "Leads", icon: Users },
  { id: "errors", label: "Erros", icon: AlertTriangle },
  { id: "auditoria", label: "Auditoria", icon: ShieldCheck },
  { id: "settings", label: "Config", icon: Settings },
];

export function AdminTabNav({ tab, setTab }) {
  return (
    <div className="bg-white border-b px-4 flex gap-1 overflow-x-auto">
      {TABS.map((t) => (
        <button
          key={t.id}
          onClick={() => setTab(t.id)}
          className={`flex items-center gap-1.5 px-4 py-3 text-xs font-bold border-b-2 transition-all whitespace-nowrap ${
            tab === t.id
              ? "border-emerald-500 text-emerald-600"
              : "border-transparent text-gray-400 hover:text-gray-600"
          }`}
          data-testid={`admin-tab-${t.id}`}
        >
          <t.icon className="w-3.5 h-3.5" /> {t.label}
        </button>
      ))}
    </div>
  );
}
